module.exports = __webpack_public_path__ + "static/media/arne.f6ff1ee5.jpg";